import { Component, Inject, ChangeDetectionStrategy } from "@angular/core";

import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

export interface IAffectedRoute {
  routeName: string;
  activationNames: string[];
}

export interface IReplaceActivationWarningData {
  affectedRoutes: IAffectedRoute[];
}

@Component({
    selector: "app-replace-activation-warning-dialog",
    templateUrl: "./replace-activation-warning-dialog.component.html",
    styleUrls: ["./replace-activation-warning-dialog.component.css"],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatDialogModule, TranslateModule]
})
export class ReplaceActivationWarningDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<ReplaceActivationWarningDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IReplaceActivationWarningData
  ) {}

  proceed(): void {
    this.dialogRef.close(true);
  }

  cancel(): void {
    this.dialogRef.close(false);
  }
}
